/*
We're explicitly defining the list of entities that might see in escape HTML strings
*/
var htmlEntities = {
  nbsp: ' ',
  cent: '¢',
  pound: '£',
  yen: '¥',
  euro: '€',
  copy: '©',
  reg: '®',
  lt: '<',
  gt: '>',
  quot: '"',
  amp: '&',
  apos: '\''
};

module.exports = htmlEntities;



/*****************
 ** WEBPACK FOOTER
 ** ../~/underscore.string/helper/htmlEntities.js
 ** module id = 407
 ** module chunks = 0
 **/